export class SubmenuButtonController {
  private readonly submenuFdcElement: HTMLElement | null = document.querySelector('.js-submenuFdcButton');
  private readonly submenuFdcButtonElement: HTMLAnchorElement | null = document.querySelector('.js-submenuFdcButton a');
  private readonly productPageFdcLink: HTMLElement | null = document.querySelector('.js-productPage .js-seriesFscLink');

  constructor() {
    if (this.submenuFdcElement) {
      window.addEventListener('scroll', () => {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          this.submenuFdcElement?.classList.add('submenu__buttonWrap--onScroll');
        } else {
          this.submenuFdcElement?.classList.remove('submenu__buttonWrap--onScroll');
        }
      });

      if (this.productPageFdcLink && this.submenuFdcButtonElement) {
        const fdcLink = this.productPageFdcLink.dataset.fdclink;
        if (fdcLink) {
          this.submenuFdcButtonElement.href = fdcLink;
        } else {
          this.submenuFdcElement.classList.add('hide');
          document.querySelector('.submenu__itemWrapper--desktopButton')?.classList.remove('submenu__itemWrapper--desktopButton');
        }
      }
    }
  }
}
